import { render } from "./SmallAccount.vue?vue&type=template&id=97421bdc&scoped=true"
import script from "./SmallAccount.vue?vue&type=script&lang=js"
export * from "./SmallAccount.vue?vue&type=script&lang=js"

import "./SmallAccount.vue?vue&type=style&index=0&id=97421bdc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-97421bdc"

export default script